export const Logo = ({ variant = "light", size = 44 }) => {
  const isDark = variant === "dark";
  const dim = { height: size, width: size };
  const img = (
    <img
      src="/logo-odc.png"
      alt="Omer-Decugis & Cie"
      className="h-full w-full object-contain"
      draggable="false"
    />
  );
  return (
    <div className="flex items-center" data-testid="app-logo" aria-label="Omer-Decugis & Cie">
      {isDark ? (
        <div
          className="flex items-center justify-center rounded-full bg-white shadow-[0_2px_10px_rgba(0,0,0,0.18)]"
          style={{ ...dim, padding: Math.round(size * 0.08) }}
        >
          {img}
        </div>
      ) : (
        <div className="flex items-center justify-center" style={dim}>
          {img}
        </div>
      )}
    </div>
  );
};
